module.exports = __webpack_public_path__ + "img/hold.ff75c0eb.svg";